class AoflAccessibilityPlugin {
  id = 'aofl_accessibility';

  async beforeDraw(chart, args, options) {
    const parts = [];

    if (options.title) {
      parts.push(await options.title);
    }

    for (const dataset of chart.data.datasets) {
      const label = (typeof dataset.ariaLabel !== 'undefined') ? dataset.ariaLabel : dataset.label;
      parts.push(`${await label}` + ':');
      const values = [];
      for (const index in dataset.data) {
        const value = dataset.data[index];
        let key = null;
        if (typeof chart.data.ariaLabels !== 'undefined') {
          key = chart.data.ariaLabels[index];
        } else if (chart.data.labels) {
          key = chart.data.labels[index];
        }

        let string;
        if (options.formatter) {
          string = await options.formatter({label, value, key});
        } else if (key) {
          string = `${await key}: ${value}`;
        } else {
          string = value;
        }

        values.push(string);
      }

      parts.push(values.join(', '));
    }
    if (chart.ctx !== null) {
      chart.ctx.canvas.setAttribute('aria-label', parts.join(' '));
    }
  }
}

export default AoflAccessibilityPlugin;
